/** Prefix for a local file chosen before Firebase upload. */
export const PENDING_DOCUMENT_LINK_PREFIX = 'pending:';

/** True when the form link is a deferred local file, not a stored URL. */
export function isPendingDocumentLink(url: unknown): boolean {
  return typeof url === 'string' && url.startsWith(PENDING_DOCUMENT_LINK_PREFIX);
}

/** Placeholder document link so required fields validate before submit upload. */
export function pendingDocumentLinkFromFile(file: File): string {
  return `${PENDING_DOCUMENT_LINK_PREFIX}${file.name}`;
}

/** Firebase/HTTP URL only — drops empty values and pending placeholders. */
export function storedDocumentLink(url: unknown): string | undefined {
  if (typeof url !== 'string' || !url || isPendingDocumentLink(url)) return undefined;
  return url;
}

/** Form patch that unlocks document validation for a deferred file pick. */
export function buildPendingDocumentFilePatch(
  key: string,
  file: File | null,
): Record<string, unknown> | undefined {
  if (key === 'contractFile') {
    if (!file) return { contractDocumentLink: '', contractDocumentName: '' };
    return {
      contractDocumentLink: pendingDocumentLinkFromFile(file),
      contractDocumentName: file.name,
    };
  }
  if (key === 'certFile') {
    if (!file) return { certDocumentLink: '', certDocumentName: '' };
    return {
      certDocumentLink: pendingDocumentLinkFromFile(file),
      certDocumentName: file.name,
    };
  }
  if (key === 'schoolReportFile') {
    if (!file) {
      return {
        'schoolReport.documentLink': '',
        'schoolReport.documentName': '',
      };
    }
    return {
      'schoolReport.documentLink': pendingDocumentLinkFromFile(file),
      'schoolReport.documentName': file.name,
      'schoolReport.uploadDate': new Date().toISOString().slice(0, 10),
    };
  }
  if (key !== 'criminalRecordFile') return undefined;
  if (!file) {
    return {
      criminalRecordDocumentLink: '',
      'criminalRecord.fileName': '',
      'criminalRecord.documentName': '',
    };
  }
  return {
    criminalRecordDocumentLink: pendingDocumentLinkFromFile(file),
    'criminalRecord.fileName': file.name,
    'criminalRecord.documentName': file.name,
    'criminalRecord.uploadDate': new Date().toISOString().slice(0, 10),
    'criminalRecord.status': 'pending',
  };
}
